import { Component } from '@angular/core';

@Component({
  selector: 'key-listing-title',
  templateUrl: './listing-title.component.html',
})
export class KeyListingTitleComponent {
}
